module.exports = __webpack_public_path__ + "img/clock-ten-thirty.2677a54c.svg";